import React, { Component } from "react";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import PieChart from "app/components/charts/PieChart";

import {
	FormControl,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";

class GenderJobCounts extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}

	}



	render() {
		let industryType = this.props.industryType;
		let totalCount = 0;
		this.props.pieData.map(e => {
			totalCount += e.y;
		});
		return (
			<div className="graph-wrapper screen-left-graph-container">
				<div className="graph-title-container">
				</div>
				<div className="graph-screen graph-screen3">
					<div className="graph-title graph-title-2" style={{ marginTop: "30px", marginBottom: "60px", marginLeft: "150px" }}>Gender</div>
					<PieChart
						height={"535px"}
						data={this.props.pieData}
						tooltipFormatter={
							function () {
								const gender = this.point.name;
								const value = this.point.y;
								let percent = parseFloat(((value / totalCount) * 100).toFixed(2));
								let tooltip = 'Industry Description: <b>' + industryType + '</b><br>';
								tooltip += 'Gender: <b>' + gender + '</b><br>';
								tooltip += 'Count: <b>' + value.toLocaleString("en-US") + '</b>' + ' ( ' + percent + '% )';
								return tooltip;
							}
						} />
				</div>
			</div>
		);
	}
}


export default GenderJobCounts;
